import React from 'react';
import { TESTIMONIALS } from '../data/constants';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { scrollToSection } from '../utils/scrollTo';

const Testimonials: React.FC = () => {
  const { setRef, isVisible } = useIntersectionObserver();
  return (
    <section id="testimonials" ref={setRef('testimonials')} className="testi-section">
      <div className="testi-inner">
        <div className="testi-header">
          <div className={`sf ${isVisible('testimonials') ? 'vis' : ''}`}>
            <div className="eyebrow">Feedback</div>
            <h2 className="section-h2-white">What Our Clients Say About Us</h2>
          </div>
          <div className={`sf ${isVisible('testimonials') ? 'vis' : ''}`} style={{ transitionDelay: '0.12s' }}>
            <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.5)', lineHeight: 1.8, marginBottom: 28 }}>
              Gulf Fibertech has delivered GRP solutions to clients across the Gulf for over two decades. Here is what our partners say about working with us.
            </p>
            <button className="btn-yellow" onClick={() => scrollToSection('contact')}>Consult Now →</button>
          </div>
        </div>

        <div className="testi-grid">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className={`testi-card sf ${isVisible('testimonials') ? 'vis' : ''}`} style={{ transitionDelay: `${i * 0.1}s` }}>
              <span className="testi-quote-mark">"</span>
              <p className="testi-quote">{t.quote}</p>
              <div className="testi-author">
                {/* <img src={t.avatar} alt={t.name} className="testi-avatar" /> */}
                <div>
                  <div className="testi-name">{t.name}</div>
                  <div className="testi-company">{t.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Testimonials;
